module.exports = __webpack_public_path__ + "static/media/yes.517b4c23.png";